module.exports = __webpack_public_path__ + "img/art-work-icon7.33578f57.png";